import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideUp = keyframes`
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: ${theme.lightBlack};
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  animation: ${fadeIn} 0.2s ease-out;
`;

export const SheetPanel = styled.div<{
  $maxHeight?: string;
  $padding?: string;
}>`
  background: ${theme.whiteText};
  border-radius: 20px 20px 0 0;
  width: 100%;
  max-height: ${(p) => p.$maxHeight ?? "75vh"};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: ${(p) => p.$padding ?? "24px 20px 20px"};
  animation: ${slideUp} 0.3s ease-out forwards;
`;

export const SheetHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
`;

export const SheetTitle = styled.h3`
  margin: 0;
  font-size: ${fontSize.font22};
  font-weight: ${fontWeight.black};
  color: ${theme.blackText};
  flex: 1;
  min-width: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;

  &:focus-visible {
    outline: 2px solid ${theme.blueText};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;
